import React from "react";
import PropTypes from "prop-types";
import { BannerContents } from "../../../components/shared/layout";
import { Button } from "../../../components/shared/actions";
import { Row, Col } from "react-bootstrap";
import { LINKS } from "@constants";
import imagensVida from "@asserts/images/vida";
import "./BannerAcidentesPessoais.css";

export const BannersAcidentesPessoaisBemEstar = (props) => {
  const { images } = props;
  return (
    <>
      <BannerContents {...props}>
        <BannerContents.Banner
          left
          backgroundImage={imagensVida.bannerSeuFuturo}
          className="text-white"
        >
          <Row>
            <Col xs={12} md={12} className="ps-md-7">
              <div
                style={{ marginTop: "50px" }}
                className="banner-seu-futuro-title"
              >
                <h4>Seu futuro protegido começa agora!</h4>
                <div style={{ marginTop: "5px" }}>
                  <p className="text-body-md mt-0 mt-md-2 banner-seu-futuro-text">
                    Contrate o Seguro Amparo e tenha uma vida <br /> mais
                    tranquila para você e para quem ama.
                  </p>
                  <p className="banner-seu-futuro-text">
                    Planos a partir de <b>R$ 40/ano.</b>
                  </p>
                </div>
              </div>
              <Button
                className="mt-3"
                blank
                secondary
                href={LINKS.amparoConfortoBanner}
              >
                Saiba mais
              </Button>
            </Col>
          </Row>
        </BannerContents.Banner>
        <BannerContents.Banner
          backgroundImage={images.bannerAcidentesPessoaisBemEstar}
          className="text-white"
          left
        >
          <Row>
            <Col xs={12} md={12} className="ps-md-7">
              <div style={{ marginTop: "50px" }}>
                <h4>
                  Proteção completa por apenas <br />
                  R$ 18,90/mês!
                </h4>
                <div style={{ marginTop: "5px" }}>
                  <p className="text-body-md mt-0 mt-md-2">
                    Família protegida e benefícios para sua saúde <br /> com o
                    Seguro Acidentes Pessoais Bem-Estar.
                  </p>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    <li>• Consultas e exames com até 65% OFF</li>
                    <li>• Até 80% OFF em farmácias</li>
                    <li>• Assistência funeral familiar</li>
                    <li>• Sorteios mensais de R$ 20 mil</li>
                  </ul>
                </div>
              </div>
              <Button
                className="mt-3"
                blank
                secondary
                href={LINKS.amparoConfortoBannerAP}
              >
                Saiba mais
              </Button>
            </Col>
          </Row>
        </BannerContents.Banner>
      </BannerContents>
    </>
  );
};
BannersAcidentesPessoaisBemEstar.defaultProps = { images: {} };
BannersAcidentesPessoaisBemEstar.propTypes = {
  images: PropTypes.objectOf(Object)
};
export default BannersAcidentesPessoaisBemEstar;
